<template>
  <ajax-select
      v-bind="$attrs"
      :multiple="true"
      :label="transc('object.city', 1)"
      :filter-attributes="['city']"
      :item-value="'city'"
      resource-url="objects/cities"
      :value="value"
      @update:value="$emit('update:value', $event)"
  >

  </ajax-select>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import AjaxSelect from '@/components/AjaxSelect';

export default {
  name: 'SelectObjectCity',
  components: {AjaxSelect},
  mixins: [
    LocaleUtils
  ],
  props: {
    value: {
      default () {
        return [];
      }
    }
  },
}
</script>
